export const customerLogos = [
  { name: 'Charisma Bookstore', src: 'https://cdn.magicpatterns.com/uploads/cwvzf2333VZ993yfyZvq13/charisma-bookstore.png' },
  { name: 'Chill Lounge & Club', src: 'https://cdn.magicpatterns.com/uploads/gby3JWS8mj3wjTKWk9hNXm/chill-lounge-club.png' },
  { name: 'Danube Home', src: 'https://cdn.magicpatterns.com/uploads/do8Rk1teNQ5P6vZxaY9Gp5/danube-home.png' },
  { name: 'Enjoy Rubis', src: 'https://cdn.magicpatterns.com/uploads/39ECWjH3xPTESEdwUfLwvo/enjoy-rubis-red_(1).svg' },
  { name: 'Essence Bar & Grill', src: 'https://cdn.magicpatterns.com/uploads/eR3MdTh2Yg5Aqjs9tQWUSi/essence-bar-grill.png' },
  { name: 'House of Tayo', src: 'https://cdn.magicpatterns.com/uploads/9DuKhvCHvw2Yzt8UqCNkJK/house-of-tayo.png' },
  { name: 'Imagine We Publishers', src: 'https://cdn.magicpatterns.com/uploads/qK3GtcWpdmEPU9GhuqMTfJ/imgnwe-publishers.png' },
  { name: 'Katina’s', src: 'https://cdn.magicpatterns.com/uploads/n8xw6LQESzdhhRYCrukEZn/katinas.png' },
  { name: 'Nature Kigali', src: 'https://cdn.magicpatterns.com/uploads/sHxNtnqLcjyFQ1mPZ9q5xP/nature-kigali.png' },
  { name: 'Pastel', src: 'https://cdn.magicpatterns.com/uploads/hHLEanAvqYReCg3QuNByRe/pastel.png' },
  { name: 'Pâtisserie by Red Ikirwa Flavours', src: 'https://cdn.magicpatterns.com/uploads/e8Afi1GHjd2CKUtHgRJZJw/patisserie-red-ikirwa.png' },
  { name: 'Saint Umi', src: 'https://cdn.magicpatterns.com/uploads/38HUui1by98XU7TFZe71Yq/saint-umi.png' },
  { name: 'Sonatubes Ltd', src: 'https://cdn.magicpatterns.com/uploads/aTk5RwT8SFDYUWDaA4ZzWr/sonatubes.png' },
  { name: 'Top Loaf Bakery', src: 'https://cdn.magicpatterns.com/uploads/saybs8vnafXDEMZFSAoU1F/top-loaf-bakery.png' },
]

export const countries = [
  { name: 'Rwanda', code: 'rw' },
  { name: 'DR Congo', code: 'cd' },
  { name: 'Uganda', code: 'ug' },
  { name: 'Tanzania', code: 'tz' },
  { name: 'Kenya', code: 'ke' },
  { name: 'Zambia', code: 'zm' },
  { name: 'Madagascar', code: 'mg' },
]

export type Solution = {
  title: string
  copy: string
  image: string
  alt: string
}

export const solutions: Solution[] = [
  {
    title: 'Retail',
    copy: 'Sell faster and keep stock under control.',
    image:
      'https://cdn.magicpatterns.com/uploads/hrSxrDybaWkqRaXzBR7V3y/ChatGPT_Image_Sep_26,_2026,_04_09_02_PM-1.png',
    alt: 'Cashier scanning groceries for a smiling customer at a supermarket checkout',
  },
  {
    title: 'Food & Beverage',
    copy: 'Manage orders, ingredients, and daily sales.',
    image:
      'https://cdn.magicpatterns.com/uploads/um4PVUwRMuB6Dq6iSx7Up4/ChatGPT_Image_Sep_26,_2026,_04_09_05_PM-4.png',
    alt: 'Restaurant server handing a plated meal to a customer across a wooden counter',
  },
  {
    title: 'Manufacturing',
    copy: 'Track materials, production, and finished goods.',
    image:
      'https://cdn.magicpatterns.com/uploads/c8Nf8XJGRxSAWm6B5i5fj7/ChatGPT_Image_Sep_26,_2026,_04_09_09_PM-1.png',
    alt: 'Two production staff checking packaged crisps beside a factory conveyor line',
  },
  {
    title: 'Services',
    copy: 'Manage clients, jobs, and payments in one place.',
    image:
      'https://cdn.magicpatterns.com/uploads/6bTCAA9T5mAFwtdRuNtBvU/ChatGPT_Image_Sep_26,_2026,_04_09_11_PM-2.png',
    alt: 'Advisor reviewing charts with a client at an office desk overlooking Kigali',
  },
  {
    title: 'Hospitality',
    copy: 'Track bookings, guests, and property income.',
    image:
      'https://cdn.magicpatterns.com/uploads/kif38iqadZcEesbQLKpsTR/ChatGPT_Image_Sep_26,_2026,_04_09_03_PM-2.png',
    alt: 'Hotel receptionist checking in a guest with a suitcase at the front desk',
  },
  {
    title: 'Healthcare',
    copy: 'Manage pharmacy sales, clinic services, stock, and payments.',
    image:
      'https://cdn.magicpatterns.com/uploads/iDUc4UaB1F5bDm8tDia9dE/ChatGPT_Image_Sep_26,_2026,_04_09_04_PM-3.png',
    alt: 'Pharmacist explaining a medicine to a customer at the pharmacy counter',
  },
]

export type Stat = {
  eyebrow: string
  value: string
  copy: string
}

export const stats: Stat[] = [
  {
    eyebrow: 'Businesses onboarded',
    value: '15,000+',
    copy: 'African businesses using Kayko to digitize their operations.',
  },
  {
    eyebrow: 'Monthly transaction value',
    value: '$10M+',
    copy: 'Business activity recorded and managed through Kayko every month.',
  },
  {
    eyebrow: 'Financing unlocked',
    value: '$1.5M+',
    copy: 'Capital accessed by businesses using verified Kayko records.',
  },
]

export type Insight = {
  title: string
  copy: string
  image: string
  alt: string
  tag: string
}

export const insights: Insight[] = [
  {
    tag: 'Guide',
    title: 'How to digitize your business records',
    copy: 'Learn how better records help you understand performance and make confident decisions.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/70fb5833-84ea-40d8-9b97-96476558b4c8.jpg',
    alt: 'Shop owner entering sales into a tablet beside a paper ledger',
  },
  {
    tag: 'Product',
    title: 'One platform for your entire business',
    copy: 'See how Kayko connects sales, inventory, expenses, and reporting in one workspace.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/a909e49b-7014-4cb7-9541-1c09b62af1c4.jpg',
    alt: 'Laptop and phone showing a business dashboard on a shop counter',
  },
  {
    tag: 'Report',
    title: 'Why growing businesses need real-time financial insights',
    copy: 'Discover how accurate, up-to-date data helps business owners manage cash flow and plan ahead.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ecd9d923-5c1a-43ac-a833-0b82a75cd9c0.jpg',
    alt: 'Business owner reviewing charts on a laptop in a small office',
  },
  {
    tag: 'Guide',
    title: 'How business records can unlock financing',
    copy: 'Learn how consistent sales and expense records can help demonstrate your business’s financial health.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d825f78d-1c2e-4866-ad21-178ec126a998.jpg',
    alt: 'Entrepreneur shaking hands with a loan officer at a bank desk',
  },
]

export const footerColumns: { heading: string; links: string[] }[] = [
  {
    heading: 'Product',
    links: [
      'Point of Sale',
      'Inventory',
      'Expenses',
      'Purchases',
      'Customer credit',
      'Reports & insights',
      'Business financing',
    ],
  },
  {
    heading: 'Industries',
    links: ['Retail', 'Food & Beverage', 'Manufacturing', 'Services', 'Hospitality', 'Healthcare'],
  },
  {
    heading: 'Company',
    links: ['About Kayko', 'Careers', 'Partners', 'Contact', 'Press'],
  },
  {
    heading: 'Resources',
    links: [
      'Customer stories',
      'Help centre',
      'Guides & insights',
      'FAQs',
      'System status',
      'API documentation',
    ],
  },
  {
    heading: 'Legal',
    links: ['Terms of service', 'Privacy policy', 'Data protection', 'Cookie policy'],
  },
]
